import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ToastrService } from 'ngx-toastr';
import { exhaustMap, of, tap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PolicyAcceptanceService } from '../../core/services/policy-acceptance.service';
import {
  policyAcceptanceAction,
  policyAcceptanceFailureAction,
  policyAcceptanceSuccessAction,
} from './policy-acceptance.actions';

@Injectable()
export class PolicyAcceptanceEffects {
  private readonly actions$ = inject(Actions);
  private readonly policyAcceptanceService = inject(PolicyAcceptanceService);
  private readonly notifyService = inject(ToastrService);

  policyAcceptance$ = createEffect(() => this.actions$.pipe(
    ofType(policyAcceptanceAction),
    exhaustMap(action => this.policyAcceptanceService.accept(action.userId, action.policyType).pipe(
      map(() => policyAcceptanceSuccessAction({ userId: action.userId })),
      catchError(() => of(policyAcceptanceFailureAction({ userId: action.userId }))),
    )),
  ));

  policyAcceptanceFailure$ = createEffect(() => this.actions$.pipe(
    ofType(policyAcceptanceFailureAction),
    tap(() => this.notifyService.error('Failed to save policy acceptance')),
  ), { dispatch: false });
}
